import apiWrapper from 'Helpers/apiWrapper'
// import { encodeParams } from 'mailup-react-helpers'
// import { useRecoilSnapshot } from 'recoil'
// import extractApiData from 'Helpers/extractApiData'

const endpoints = (baseURL => {
  return {
    getMocAuthTokenApi: () => `${baseURL}/token`
  }
})(process.env.MOCAUTH_URL)

export const getMocAuthTokenApi = () => {
  const url = endpoints.getMocAuthTokenApi()

  return apiWrapper({
    method: 'post',
    url: url
  }).then(res => res.data)
}
